import React from "react";

export const LoadingOverlay = ({ message }) => {
  return (
    <div className="fixed inset-0 bg-slate-900 bg-opacity-60 backdrop-blur-sm z-50 flex justify-center items-center transition-opacity duration-300">
      <div className="bg-white/95 p-8 md:p-12 rounded-2xl shadow-2xl text-center max-w-md mx-4">
        <svg
          className="animate-spin h-12 w-12 text-blue-800 mx-auto mb-6"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        <h2 className="text-xl font-bold text-slate-800 mb-2">Aguarde um momento...</h2>
        <p className="text-base text-slate-600">{message}</p>
      </div>
    </div>
  );
};
